<div class="content content-md">
  <div [ngClass]="scrollContentClass">
    @if (isBusy || searchService.isSearching) {
      <app-overlay imgClass='cg-overlay-img'></app-overlay>
    }
    @if (!searchService.isSearching && !searchResults && assetUnavailabilitySummary) {
      <div>
        <div id="content-list" class="list list-md">
          <button class="item item-block item-md button-shade" text-wrap=""
            (click)="openEquipmentAssetByStatus(null)">
            <div class="item-inner">
              <div class="input-wrapper">
                <div class="list-label label label-md">
                  <h2 class="ellipses-label">{{this.translateService.instant('main.data.all_unavailable')}}</h2>
                  <p class="ellipses-sublabel"
                    [innerHTML]="getLabelTranslation('Asset_count', [assetUnavailabilitySummary.asset_count | number])">
                  </p>
                </div>
                <app-item-arrow></app-item-arrow>
              </div>
              <div class="button-effect"></div>
            </div>
          </button>
          <div class="pie-container">
            <canvas baseChart style="cursor: pointer;" [datasets]="pieChartDatasets" [type]="'pie'"
              [options]="pieChartOptions" [plugins]="pieChartPlugins" [labels]="pieChartLabels"
              (chartClick)="chartClicked($event)" [legend]="pieChartLegend">
            </canvas>
          </div>
          <div class="availability-container">
            @for (assetAvailability of assetAvailabilities; track assetAvailability) {
              <div style="vertical-align:middle">
                <button class="item item-block item-md" text-wrap=""
                  (click)="openEquipmentAssetByStatus(assetAvailability.status_label)">
                  <div class="item-inner">
                    <div class="input-wrapper">
                      <div class="list-label label label-md">
                        <div class="availability-label" [style.color]="assetAvailability.label_color">
                        {{assetAvailability.status_label}}</div>
                        <div class="availability-sublabel"
                          [style.color]="assetAvailability.label_color">
                        {{assetAvailability.asset_percent}}%</div>
                        <p class="ellipses-sublabel"
                          [innerHTML]="getLabelTranslation('Asset_count', [assetAvailability.asset_count | number])">
                        </p>
                      </div>
                      <app-item-arrow></app-item-arrow>
                    </div>
                    <div class="button-effect"></div>
                  </div>
                </button>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
  @if (searchResults) {
    <app-search-results />
  }
</div>
